import { CalendarComponentOptions } from 'ion2-calendar';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ServisDetayPage } from '../../ServisKayit/servis-detay/servis-detay';

/**
 * Generated class for the PersonelServisRaporuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-personel-servis-raporu',
  templateUrl: 'personel-servis-raporu.html',
})
export class PersonelServisRaporuPage {
  sunucuadresi: any;
  aranan = "";
  gizle = 1;
  skip: number = 0;
  take: number = 50;
  isListesi = [];
  personelListesi = [];
  secilenpersonelid: number = 0;
  tarih1: any;
  tarih2: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string';
  optionsRange: CalendarComponentOptions = {
    from: new Date(2018, 1, 1),
    pickMode: 'range',
    color: "danger"
  };
  @ViewChild('sideNavUrunAra') sideNav;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams) {
      this.sunucuadresi = this.ortak.storageSunucuAdresiGetir;
      this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
      this.tarih2 = this.tarih1;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.KayitAra2(null);
    this.personelleriGetir();
  }
  ionViewDidEnter() {
    this.KayitAra2(null);

  }
  kayitAraTarihli(e) {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    formData.append("aranan", this.aranan);
    formData.append("personelid",this.secilenpersonelid.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "PersonelBazliServisRaporTarihli", "", false).then(a => {
      var sonuc = <any>a;
      this.isListesi = sonuc.SonucObject;

    })
    this.closeNav();
  }
  KayitAra2(e) {
if(this.secilenpersonelid!=0)
{
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("take", this.take.toString());
  formData.append("personelid",this.secilenpersonelid.toString());
  this.bllOrtak.islem(formData, "PersonelBazliServisRapor", "", false).then(a => {
    var sonuc = <any>a;
    this.isListesi = sonuc.SonucObject;

  })
}
   

  }
  iskayitlari(e) {
    if (e.keyCode == 13) {
      this.KayitAra2(e);
    }
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  servisdetay(isler) {
    let modal = this.modalCtrl.create(ServisDetayPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  personelleriGetir() {
    this.bllOrtak.islemWithoutPost("PersonelGetirServisKayit", "", false).then(a => {
      var sonuc = <any>a;
      this.personelListesi = sonuc.SonucObject;
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/personel-servis-raporu/personel-servis-raporu.ts